<template>
    <div class="contrast">
        <div class="contrast-item tit">
            <div class="contrast-item-label"
                 :style="{width:labelWidth}">名称
            </div>
            <div class="contrast-item-info">修改前信息</div>
            <div class="contrast-item-info">修改后信息</div>
        </div>
        <div class="contrast-item" v-for="(item,key,index) in showInfo" v-if="!item.hide">
            <div class="contrast-item-label"
                 :style="{width:labelWidth}">{{item.label}}
            </div>
            <div class="contrast-item-info">{{getShow(key).Old}}</div>
            <div class="contrast-item-info" :class="getShow(key).c">{{getShow(key).New}}</div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">

    export default {
        name: 'sContrast',
        props: ['showInfo', 'oldData', 'newData', 'labelWidth'],
        data() {
            return {}
        },
        created() {

        },
        mounted() {
        },
        methods: {
            /**
             * 获取旧数据的展示
             * @param key
             */
            getShow(key) {
                let c = "diff";
                let Old = "";
                let New = "";

                let label = this.showInfo[key].label;

                let o = {};
                o[key] = {...this.showInfo[key]};
                o[key].value = this.oldData[key].value;

                let n = {};
                n[key] = {...this.showInfo[key]};
                n[key].value = this.newData[key].value;
                Old = this.$showSItem(o)[label];
                New = this.$showSItem(n)[label];

                if (Old == New) {
                    c = ''
                }

                return {
                    c,
                    Old,
                    New
                }
            }
        }
    }
</script>

<style lang="scss">
    .contrast {
        width: 100%;

        &-item {
            width: 100%;
            display: flex;
            height: 40px;
            background-color: #f8f8f9;
            color: #515a6e;
            border-top: 1px solid #dcdee2;

            &-label {
                width: 100px;
                flex-shrink: 0;
                flex-grow: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: #e8eaec;
            }

            &-info {
                flex-shrink: 1;
                flex-grow: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 50%;

                &:last-child {
                    background-color: #e8eaec;
                }

                &.diff {
                    color: #ed4014;
                }
            }

            &.tit {
                font-size: 15px;
                color: #17233d;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/s-input/sContrast.vue